import { Person, Settings } from "@material-ui/icons";
import NetworkIcon from "./components/icons/NetworkIcon";
import RaffleIcon from "./components/icons/RaffleIcon";

export const navigations = [
  {
    icon: RaffleIcon,
    title: "Raffles",
    link: "/raffles",
  },
  {
    icon: Person,
    title: "Profile",
    link: "/profile",
  },
  {
    icon: NetworkIcon,
    title: "Proxies",
    link: "/proxies",
  },
  {
    icon: Settings,
    title: "Settings",
    link: "/settings",
  },
];
